import AboutHero from '../components/shared/AboutHero';
import Timeline from '../components/shared/Timeline';
import BeforeFooter from '../components/layout/BeforeFooter';
function About() {
  return (
    <div>
      <AboutHero />
      <Timeline />
      <BeforeFooter />
    </div>
  );
}

export default About;
